import { Repo } from '../repo.service';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import {
	ApplicationDefaults,
	ICloserDefaults,
} from '@models/applicationDefaults';
import { CollectionPaths } from '@models/collections';

@Injectable({
	providedIn: 'root',
})
export class ApplicationDefaultsRepo extends Repo<
	ApplicationDefaults | ICloserDefaults,
	null
> {
	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(): string {
		return CollectionPaths.applicationDefaults();
	}

	GetCloserDefaults() {
		return this.Get$('closer');
	}
}
